module.exports = __webpack_public_path__ + "static/media/logo.35fc9c06.png";